import { Dispatch } from "redux";
import { getAppState } from "src/store";
import {
    getLocalAccountSettingsState,
    LocalAccountSettingsState,
    setLocalAccountSettingsState,
} from "src/utils/localStorage";
import { AccountAction, GetAccountResponseErrorAction, GetAccountResponseSuccessAction } from "../actions/account";
import { AccountResponses, AccountRoutes } from "../types";
import { getFrom } from "./shared/osfetch";
import { findRoute } from "./util";
import { analyticsFEA } from "src/AnalyticsFEA";

export const getData = async (next: Dispatch, action: AccountAction) => {
    const appState = getAppState();
    const env = (appState && appState.onlineShopper && appState.onlineShopper.env) || "dev";
    const storedData: LocalAccountSettingsState =
        getLocalAccountSettingsState({
            env,
            slug: action.data.account_slug,
        }) || {};
    const headers = {};
    // read eTag off storedData and inject "If-None-Match": "eTag" header to fetch
    if (storedData) {
        headers["If-None-Match"] = storedData.eTag;
    }

    // pass headers obj into this fetch wrapper
    const response = await getFrom(
        `/accounts/${action.data.account_slug}?expand[address]=*&expand[phone]=*&expand[integration_settings]=*&expand[account_disclaimers]=*&expand[front_end_analytics_config]=*&expand[analytics]=*`,
        next,
        headers
    );

    if (response.ok || response.status === 304) {
        const data = response.status === 304 ? storedData.data : await response.json();

        // read eTag/data off response and overwrite it on the localStore
        setLocalAccountSettingsState({
            env,
            slug: action.data.account_slug,
            data,
            eTag: response.headers.get("eTag")?.replace(/[W/\\"]/g, ""),
        });

        await next({
            data,
            type: AccountResponses.GetSuccess,
        } as GetAccountResponseSuccessAction);

        analyticsFEA.initialize(action.data.iframe);
    } else {
        const data = await response.json();

        console.error(`Error getting account info for account: ${action.data.account_slug}. Reason: ${data.message}`);

        next({
            account: action.data.account_slug,
            data,
            type: AccountResponses.GetError,
        } as GetAccountResponseErrorAction);
    }
};

const routes = {
    [AccountRoutes.GetAccount]: getData,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
